import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "src/authConfig";

const MsalInstance = new PublicClientApplication(msalConfig);

export default MsalInstance;
